import { z } from 'zod';

export const FEEDBACK_MAX_LENGTH = 2000;

export const feedbackSchema = z
  .object({
    text: z.string().trim().min(1).max(FEEDBACK_MAX_LENGTH),
  })
  .strict();

export type FeedbackInput = z.infer<typeof feedbackSchema>;
